import { create } from "zustand";

interface AuthStoreIFace {
  username: string | null;
  setUsername: (username: string | null) => void;
}

const useAuthStore = create<AuthStoreIFace>((set) => ({
  username: null,
  setUsername: (username) => set({ username }),
}));

export default useAuthStore;
